import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["fill"];
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WarningsSVG',
    setup(__props) {
        const store = useStore();
        const consumerColors = computed(() => store.getters.getConsumerColors);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M16.8755 14.5342C16.8337 14.5342 16.7918 14.5238 16.7537 14.5032L12.0627 11.9574L12.1563 3.08095L16.7519 0.532006C16.8307 0.488216 16.9267 0.489462 17.0048 0.535119C17.0824 0.580569 17.1303 0.663998 17.1303 0.753861V14.2803C17.1303 14.3698 17.0828 14.4528 17.0056 14.4985C16.9656 14.5223 16.9207 14.5342 16.8755 14.5342ZM7.78022 10.1191H3.72131C3.58061 10.1191 3.46675 10.0053 3.46675 9.86504C3.46675 9.72475 3.58061 9.61123 3.72131 9.61123H7.78022C7.92093 9.61123 8.035 9.72475 8.035 9.86504C8.035 10.0053 7.92093 10.1191 7.78022 10.1191ZM7.78022 8.55363H3.72131C3.58061 8.55363 3.46675 8.4399 3.46675 8.29982C3.46675 8.15952 3.58061 8.04579 3.72131 8.04579H7.78022C7.92093 8.04579 8.035 8.15952 8.035 8.29982C8.035 8.44011 7.92093 8.55363 7.78022 8.55363ZM7.78022 6.98841H3.72131C3.58061 6.98841 3.46675 6.87468 3.46675 6.73438C3.46675 6.59409 3.58061 6.48057 3.72131 6.48057H7.78022C7.92093 6.48057 8.035 6.59409 8.035 6.73438C8.035 6.87468 7.92093 6.98841 7.78022 6.98841ZM7.78022 5.42297H3.72131C3.58061 5.42297 3.46675 5.30924 3.46675 5.16916C3.46675 5.02886 3.58061 4.91514 3.72131 4.91514H7.78022C7.92093 4.91514 8.035 5.02886 8.035 5.16916C8.035 5.30924 7.92093 5.42297 7.78022 5.42297ZM11.5552 11.7798H4.77538C2.41789 11.7798 0.5 9.86753 0.5 7.5172C0.5 5.16667 2.41789 3.25444 4.77538 3.25444H11.6451L11.5552 11.7798Z",
                    fill: consumerColors.value?.primary_color
                }, null, 8, _hoisted_2),
                _cache[0] || (_cache[0] = _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M17.6396 3.98419C19.2724 4.33493 20.5 5.78559 20.5 7.51685C20.5 9.2481 19.2724 10.6988 17.6396 11.0493V3.98419Z",
                    fill: "#AFAFAF"
                }, null, -1)),
                _cache[1] || (_cache[1] = _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M6.92858 20.5C5.6008 20.5 4.52051 19.4229 4.52051 18.099V12.2806C4.60481 12.2851 4.68973 12.2874 4.77528 12.2874H9.33666V18.099C9.33666 19.4231 8.25657 20.5 6.92879 20.5H6.92858Z",
                    fill: "#AFAFAF"
                }, null, -1))
            ]));
        };
    }
});
